<template>
<div class="myOrder">
  <!--<van-tabs v-model="active"  @click="tabClick">-->
    <!--<van-tab v-for="(item, index) in titleList" :key="index" :name="item.name" :title="item.title">-->
      <div v-if="orderList.length === 0 && !incomeListLoading" class="empty_icon">
        <img src="../../assets/images/publicImg/empty_icon.png">
        <div class="blank-tip">暂无内容</div>
      </div>
      <van-list
        v-else
        v-model="incomeListLoading"
        :finished="listLoadFinished"
        @load="getOrderList"
      >
      <div >
        <div v-for="(item, index) in orderList" :key="index" class="orderBox" @click="productDetail(item.goodsId)">
          <div class="top">
            <div class="imgBox">
              <img :src="item.goodsFile" class="img">
              <div class="name">{{item.goodsName}}</div>
            </div>
            <div class="rightBox">
              <div class="statusName" v-if="item.status == 1">已支付</div>
              <div class="statusName" v-if="item.status == 2">已退款</div>
              <div class="statusName" v-if="item.status == 3">待收货</div>
              <div class="integral">{{item.goodsPrice}}<span>积分</span></div>
            </div>
          </div>
          <div class="timeBox clearfix">
            <span class="time">{{item.createTime}}</span>
             <!--<span class="button" @click.stop="drawback(item.id)" v-if="item.status !== 2">申请退款</span>-->
          </div>
        </div>
      </div>
      </van-list>
    <!--</van-tab>-->
  <!--</van-tabs>-->
  <Tabbar/>
</div>
</template>

<script>
import Tabbar from './scoreIndex'
import { orderList, scoreRefund } from '@api/integralMall'
export default {
  name: 'myOrder',
  components: {
    Tabbar
  },
  data () {
    return {
      active: '0',
      titleList: [
        { name: '0', title: '全部' },
        { name: '1', title: '已支付' },
        { name: '3', title: '待收货' },
        { name: '2', title: '已退款' }
      ],
      pageSize: 10,
      pageNum: 0,
      listLoadFinished: false,
      incomeListLoading: false,
      status: 0,
      orderList: []
    }
  },
  created () {
    this.getOrderList()
  },
  methods: {
    getOrderList () {
      this.pageNum++
      this.incomeListLoading = true
      orderList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: this.status
      }).then(res => {
        if (res.data.code === 200) {
          this.incomeListLoading = false
          if (res.data.data.rows && res.data.data.rows.length === 0) {
            this.listLoadFinished = true
          } else {
            this.orderList = this.orderList.concat(res.data.data.rows)
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    drawback (id) {
      scoreRefund({
        orderId: id
      }).then(res => {
        if (res.data.code === 200) {
          this.$toastMsg('退款成功')
          this.orderList = []
          this.pageNum = 0
          this.pageSize = 10
          this.getOrderList()
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    tabClick (name) {
      this.orderList = []
      this.status = name
      this.pageNum = 0
      this.pageSize = 10
      this.getOrderList()
    },
    productDetail (id) {
      const data = {
        url: `${process.env.VUE_APP_BASE_HOST}/proDuctDetail?id=${id}`,
        title: '积分商城'
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
      // this.enterRouter('proDuctDetail', { id: id })
    }
  }
}
</script>

<style lang="scss">
  @import "../../assets/css/mixin";
.myOrder{
  padding-bottom: 60px;
  .orderBox{
    margin: 12px;
    padding: 12px;
    background: #fff;
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.04);
    opacity: 1;
    border-radius: 5px;
    .top{
      display: flex;
      width: 100%;
      justify-content: space-between;
      padding-bottom: 12px;
      border-bottom: 1px solid #eee;
      .imgBox{
        display: inherit;
      }
      .img{
        width: 60px;
        height: 60px;
        object-fit: cover;
        object-position: center;
        margin-right: 8px;
      }
      .name{
        @include add_size($font_size_17);
        font-weight: bold;
        color: #333;
      }
      .rightBox{
        text-align: right;
        .statusName{
          @include add_size($font_size_14);
          color: #999999;
          margin-bottom: 16px;
        }
        .integral{
          @include add_size($font_size_17);
          color: #FF7519;
          font-weight: bold;
        }
      }
    }
    .timeBox{
      margin-top: 12px;
      .time{
        @include add_size($font_size_13);
        color: #999999;
        vertical-align: top;
      }
      .button{
        float: right;
        display: inline-block;
        width: 95px;
        height: 25px;
        line-height: 23px;
        border-radius: 12px;
        border: 1px solid #707070;
        font-size: 14px;
        color: #333;
        text-align: center;
        vertical-align: middle;
      }
    }
  }
  .van-tabbar-item__icon img{
    width: 20px;
  }
}
</style>
